<div class="multi-reward-popup">
    <div class="reward-popup">
        @if (onClaimRewardFailure) {
            <div class="content-message error theme-error-i reward-popup-error">
                <div class="pc-text pc-component">
                    <span class="pc-richtext">{{ onClaimRewardFailureMessage }}</span>
                    <span class="error-text"
                        ><a [href]="edsContent?.contactUsCta?.url" (click)="onContactUsCtaClick(); $event.preventDefault()">{{
                            edsContent?.contactUsCta?.text
                        }}</a></span
                    >
                </div>
                <div class="close-icon" (click)="onCloseErrorBanner()"><span class="ui-icon ui-icon-size-md ui-close theme-ex"></span></div>
            </div>
        }
        <div class="reward-popup-header">
            <div (click)="onClosePopup(); webTrackingForCloseAndNotNow('close', 'select rewards popup')" class="header-ctrl-r">
                <span class="ui-icon ui-icon-size-lg ui-close theme-ex"></span>
            </div>
            <div class="reward-popup-header__heading">{{ eventData?.rewardPopupTitle }}</div>
            <div class="reward-popup-header__description" [vnDynamicHtml]="edsContent?.titleImage?.parameters?.description"></div>
        </div>
        <div class="reward-popup-list scrollable-cards">
            @for (reward of eventData?.playerRewards; track reward; let rewardIndex = $index) {
                <div class="reward-popup-item" [ngClass]="{ yel_bg: reward?.isRewardSelected }">
                    <div class="reward-popup-item-info">
                        @if (reward?.rewardImage) {
                            <img [src]="reward.rewardImage" class="reward-popup-item-info__icon" />
                        }
                        <div class="reward-popup-item-info__text">
                            <div class="reward-popup-item-info__text--heading">{{ reward?.rewardListDescription }}</div>
                            <div class="reward-popup-item-info__text--descriptiton">{{ reward?.rewardDescription }}</div>
                        </div>
                    </div>
                    <div class="reward-popup-item-button">
                        <img
                            [src]="reward?.rewardBackgroundImage?.src"
                            [alt]="reward?.rewardBackgroundImage?.alt"
                            class="reward-popup-item-button__img" />
                        @if (reward?.rewardStatus !== 'Claimed' && !reward?.isRewardSelected) {
                            <button
                                ds-button
                                [size]="dsButtonConfig?.choose?.size"
                                [variant]="dsButtonConfig?.choose?.variant"
                                [kind]="dsButtonConfig?.choose?.kind"
                                (click)="chooseReward(reward, rewardIndex)"
                                class="reward-popup-item-button__btn">
                                {{ clientContent?.messages?.choose }}
                            </button>
                        }
                        @if (reward?.rewardStatus === 'Claimed') {
                            @if (reward?.resultPrize?.showCta && reward?.resultPrize?.checkPromoLink?.url != null) {
                                <a
                                    class="reward-popup-item-button__text"
                                    [href]="reward?.resultPrize?.checkPromoLink?.url"
                                    (click)="onClickGoToRewardCta(reward); $event.preventDefault()"
                                    >{{ reward?.resultPrize?.checkPromoLink?.text }}
                                </a>
                            } @else if (reward?.resultPrize != null && !reward?.resultPrize?.showCta) {
                                <div class="reward-popup-item-button__claimed">{{ clientContent?.messages?.rewardclaimed }}</div>
                            } @else {
                                <span class="theme-success-i used-prize-icon"></span>
                            }
                        }
                    </div>
                </div>
            }
        </div>
    </div>
    @if (isDesktop) {
        <div class="reward-popup-select">
            <div class="reward-popup-select__description">
                <div class="reward-popup-select__description--text">{{ rewardTnc }}</div>
            </div>
            <button
                ds-button
                [size]="dsButtonConfig?.select?.size"
                [variant]="dsButtonConfig?.select?.variant"
                [kind]="dsButtonConfig?.select?.kind"
                (click)="onClickSelect()"
                [class.disabled]="isButtonDisabled">
                {{ clientContent?.messages?.select }}
            </button>
        </div>
    }
    @if (!isDesktop) {
        <div class="select-close">
            <div class="reward-popup-select">
                <button
                    ds-button
                    class="w-100"
                    [size]="dsButtonConfig?.select?.size"
                    [variant]="dsButtonConfig?.select?.variant"
                    [kind]="dsButtonConfig?.select?.kind"
                    (click)="onClickSelect()"
                    [class.disabled]="isButtonDisabled">
                    {{ clientContent?.messages?.select }}
                </button>
                @if (rewardTnc) {
                    <div class="reward-popup-select__description">
                        <div class="reward-popup-select__description--text">{{ rewardTnc }}</div>
                    </div>
                }
            </div>
            <div class="reward-popup-close">
                <a
                    class="reward-popup-close__button"
                    href="#"
                    (click)="onClosePopup(); webTrackingForCloseAndNotNow('close', 'select rewards popup'); $event.preventDefault()">
                    {{ clientContent?.messages?.close }}
                </a>
            </div>
        </div>
    }
</div>
